import { ItemTypeConsts } from 'client/util/Constants';

export const membershipMethodKeys = {
  STATIC: 'STATIC',
  DYNAMIC_AUTOMATED: 'DYNAMIC_AUTOMATED',
  DYNAMIC_REVIEW_REQUIRED: 'DYNAMIC_REVIEW_REQUIRED',
};

export const MEMBERSHIP_UPDATES_COLUMN = {
  name: 'Update',
  dataField: 'suggestion',
  classNames: {
    body: ['updatesCell'],
    heading: ['updatesHeading'],
  },
  headingText: 'Update',
  sortBy: undefined,
};

export const MEMBERSHIP_EXEMPTION_COLUMN = {
  bodyComponent: 'MembershipExemptionColumn',
  name: 'Exemption',
  headingText: 'Exemption',
};

export const MEMBERSHIP_METHOD_STRINGS = {
  [membershipMethodKeys.STATIC]: 'Static',
  [membershipMethodKeys.DYNAMIC_AUTOMATED]: 'Dynamic',
  [membershipMethodKeys.DYNAMIC_REVIEW_REQUIRED]: 'Dynamic (Review Required)',
};

export const MEMBERSHIP_CONTROL = {
  bodyComponent: 'MembershipControl',
  headingText: 'User Membership Controls',
};

export const EXEMPTION_TYPES = {
  [ItemTypeConsts.systemGroup]: 'SYSTEM',
  [ItemTypeConsts.userGroup]: 'USER',
};

export const MAX_EXEMPTIONS_COUNT = 25;

export default membershipMethodKeys;
